// extracted by mini-css-extract-plugin
export default {"btn":"BackButton_btn__WdDw9","homeBtn":"BackButton_homeBtn__oUJzl"};